import { useMutation, useQuery } from "@tanstack/react-query";
import { paymentsService } from "@/services/paymentsService";
import type { PaymentFilterParams, VerifyPaymentDto } from "@/types/payment.dto";
import { mapPaymentListDtosToAdminRows } from "@/lib/mappers/admin-mappers";
import { queryKeys } from "./keys";

export function usePaymentByOrderId(orderId: number, enabled = true) {
  return useQuery({
    queryKey: queryKeys.payments.byOrder(orderId),
    queryFn: () => paymentsService.getByOrderId(orderId),
    enabled: enabled && orderId > 0,
  });
}

export function useCreatePaymentOrderMutation() {
  return useMutation({
    mutationFn: (orderId: number) => paymentsService.createOrder(orderId),
  });
}

export function useVerifyPaymentMutation() {
  return useMutation({
    mutationFn: (dto: VerifyPaymentDto) => paymentsService.verify(dto),
  });
}

export function useAdminPayments(filter: PaymentFilterParams = { pageSize: 100 }) {
  return useQuery({
    queryKey: queryKeys.admin.payments(filter),
    queryFn: async () => {
      const result = await paymentsService.getAll(filter);
      return {
        ...result,
        items: mapPaymentListDtosToAdminRows(result.items),
      };
    },
  });
}
